import LoadingScreen from 'components/LoadingScreen';
import PageLayout from 'components/PageLayout';
import DashboardActions from './DashboardActions';
import { FilterConfig } from 'components/SearchAndFilters/FilterTypes';
import ActiveFiltersBar from 'components/SearchAndFilters/SelectedFiltersBar';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { Suspense } from 'react';
import { Row, Col, CardTitle } from 'reactstrap';

import Filters from './Filters';
import { useFilterConfig } from './Filters.config';
import {
  waListingDataAtom,
  useOnFilterChangeResetAtoms,
  filterValuesAtom,
} from './state';
import WADataGrid from './WADataGrid';
import WAInsights from './WAInsights';

const SelectedFilters: React.FC<{ filtersConfig: FilterConfig }> = ({
  filtersConfig,
}) => {
  const setFilterValues = useSetAtom(filterValuesAtom);
  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();

  return (
    <Suspense fallback={<></>}>
      <ActiveFiltersBar
        filtersConfig={filtersConfig}
        onFiltersReset={() => {
          setFilterValues({ ...filtersConfig.getActiveFilterValues() });
          resetOnFilterChangeAtoms();
        }}
      />
    </Suspense>
  );
};

const ListingCount: React.FC = () => {
  const listingData = useAtomValue(waListingDataAtom);
  return <>{listingData?.loading ? '...' : listingData.count}</>;
};

function WAListing() {
  const filtersConfig = useFilterConfig();
  return (
    <PageLayout
      id="wa_listing"
      heading={
        <Row>
          <Col md="auto" sm="12">
            <CardTitle>
              <h4>
                WebApps
                <label id="counts" className="label btn">
                  <Suspense fallback={<>...</>}>
                    <ListingCount />
                  </Suspense>
                </label>
              </h4>
            </CardTitle>
          </Col>
        </Row>
      }
      subheading="List of WebApps."
      filteringOptions={<Filters filtersConfig={filtersConfig} />}
    >
      <Suspense fallback={<LoadingScreen />}>
        <div className="container-fluid p-0">
          <div className="row mb-1">
            {/* Expanding Column */}
            <div className="col">
              <SelectedFilters filtersConfig={filtersConfig} />
            </div>

            {/* Fixed Column with Right-Aligned Content */}
            <div className="col-auto text-right align-baseline">
              <Suspense fallback={<>...</>}>
                <DashboardActions />
              </Suspense>
            </div>
          </div>
          <Suspense fallback={<LoadingScreen />}>
            <WAInsights />
          </Suspense>
          <Suspense fallback={<LoadingScreen />}>
            <WADataGrid />
          </Suspense>
        </div>
      </Suspense>
    </PageLayout>
  );
}

const WAList = () => {
  return (
    <Suspense fallback={<LoadingScreen height={500} />}>
      <WAListing />
    </Suspense>
  );
};

export default WAList;
